module.exports = __webpack_public_path__ + "img/hangye3.f99c4377.png";